import React from 'react';
import { StyledCheckbox } from './style';
import classnames from 'classnames';
import uuid from 'uuid/v4';

const StandardCheckbox = React.forwardRef(({ className, ...rest }, ref) => {
  const { disabled, name } = rest;
  return (
    <StyledCheckbox
      id={name || uuid()}
      type="checkbox"
      className={classnames('form-check-inline', className, { disabled })}
      {...{ ref, ...rest }}
    />
  );
});

export default StandardCheckbox;
